import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import 'intersection-observer'; // Polyfill for IntersectionObserver

import useIsInViewport from 'use-is-in-viewport';
import useImpressionImpl from './useImpressionImpl';
/**
 * The web platform provides ways for elements to identify for themselves when
 * they are visible on screen. This hook is a simple wrapper around
 * `useImpressionImpl` that uses the `IntersectionObserver` API to set the
 * `isVisible` flag for that hook. The `ref` property on the return value of
 * this hook should be attached to the component being tracked via its `ref`
 * prop.
 */

var useImpression = function useImpression(_ref) {
  var eventType = _ref.eventType,
      elementName = _ref.elementName,
      entityName = _ref.entityName,
      payload = _ref.payload,
      refireOnEventChange = _ref.refireOnEventChange;

  var _useIsInViewport = useIsInViewport(),
      _useIsInViewport2 = _slicedToArray(_useIsInViewport, 2),
      isInViewport = _useIsInViewport2[0],
      ref = _useIsInViewport2[1];

  var impression = useImpressionImpl({
    eventType: eventType,
    elementName: elementName,
    entityName: entityName,
    payload: payload,
    isVisible: isInViewport,
    refireOnEventChange: refireOnEventChange
  });
  return _objectSpread({}, impression, {
    ref: ref
  });
};

export default useImpression;